import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { CampaignService } from "../services/Campaign.service";
import {
  ICreateManualPayout,
  ICreatePayout,
} from "@shared/lib/types/briefCampains";
import { FINANCE_INFLUENCER_QUERY_KEY } from "../contsants";

export function useCreatePayout(campaignInfluencerId: string) {
  const {
    mutate: createPayout,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation<ICreatePayout>({
    mutationFn: async (payout) => {
      return await CampaignService.createPayout(payout).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...FINANCE_INFLUENCER_QUERY_KEY(campaignInfluencerId)],
      });
      // TODO: Invalidate relevant queries here
    },
    options: {},
  });

  return {
    createPayout,
    isCreating,
    isCreated,
  };
}
